import {Breadcrumb, Divider, Layout, Menu} from 'antd';
import {FC, useState} from 'react';
import {AuditOutlined, BookOutlined, LogoutOutlined} from '@ant-design/icons';
import './Nelar.css';

import {Diaries} from './diaries/Diaries';

import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import {DevPlayGround} from './DevPlayGround';
import {Login, logout} from './login';
import {DiariesManager} from './diaries/DiariesManager';

const {Content, Footer, Sider} = Layout;

export const Nelar: FC = () => {
  const [state, setState] = useState({
    navCollapsed: true,
  });

  return (
    <Router>
      <Login />
      <Layout style={{minHeight: '100vh'}}>
        <Sider
          collapsible
          collapsedWidth={60}
          collapsed={state.navCollapsed}
          onCollapse={(navCollapsed: boolean) => setState({...state, navCollapsed: navCollapsed})}
        >
          {/* todo: make logo work, logo link to home */}
          <div style={{
            // this magic from: https://github.com/ant-design/ant-design/issues/13572#issuecomment-527409028
            // it allowed space-between work on children
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
          }}>
            <Menu theme="dark" mode="inline">
              <Menu.Item key="diaries" icon={<BookOutlined />}><Link to={process.env.PUBLIC_URL + '/diaries'}>日记</Link></Menu.Item>
              <Menu.Item key="events-dashboard" icon={<AuditOutlined />}><Link to={process.env.PUBLIC_URL + '/events-dashboard'}>事件簿</Link></Menu.Item>
            </Menu>
            <Menu theme="dark" mode="inline" >
              <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logout}>Logout</Menu.Item>
            </Menu>
          </div>
        </Sider>
        <Layout className="site-layout">
          <Content style={{
            margin: '0 16px', // magic: if delete this, page may vibrate when click button or other things like that
          }}>
            <Divider orientation="left"><Breadcrumb>
              {/* todo[next]: implment breadcrumb */}
              <Breadcrumb.Item>TODO</Breadcrumb.Item>
              <Breadcrumb.Item>Implmenet Here</Breadcrumb.Item>
            </Breadcrumb></Divider>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/diaries">
                <Diaries />
              </Route>
              <Route path="/diaries_manager/:tab?" render={({match, history})=>{
                return <DiariesManager activeTab={match.params.tab ? match.params.tab : 'search'} onTabChange={(tab)=>{
                  history.push(`/diaries_manager/${tab}`);
                }} />;
              }}/>
            </Switch>
          </Content>
          <Footer style={{textAlign: 'center'}}>Nelar: created by QisFj</Footer>
        </Layout>
      </Layout>
    </Router>
  );
};

const Home: FC = () => {
  return <DevPlayGround></DevPlayGround>;
};
